import { METHOD_TYPE } from "@constants/Enums";

export const userHeaderMapping = {
  id: "id",
  last_name: "氏名（姓）",
  first_name: "氏名（名）",
  last_furigana_name: "かな（せい）（任意）",
  first_furigana_name: "かな（めい）（任意）",
  employee_number: "社員番号（任意）",
  email: "メールアドレス（任意）",
  secondary_email: "メールアドレス 2（任意）",
  personal_tel: "電話番号",
  secondary_phone_number: "電話番号 2（任意）",
  login_id: "ユーザーID",
  login_password: "パスワード",
  is_display: "アカウント状態（有効：TRUE、無効：FALSE）",
  role: "権限　（１：一般者、　２：管理者、　３：連絡先）",
  display_order: "部署コード（任意）",
  position_name: "役職（任意）",
  broadcast_group_code: "一斉発信グループコード（任意）",
  company_name: "企業名 （任意）",
  company_tel: "企業電話番号 （任意）",
  company_fax: "企業FAX番号 （任意）",
  company_address: "企業住所 （任意）",
  company_postal_code: "企業郵便番号 （任意）",
  company_home_page: "企業ホームページ （任意）",
  apps: "利用アプリ",
  notes: "そのほか情報（任意）",
  delete: "削除フラグ",
};

export const contactHeaderMapping = {
  id: "id",
  last_name: "氏名（姓）",
  first_name: "氏名（名）",
  last_furigana_name: "かな（せい）（任意）",
  first_furigana_name: "かな（めい）（任意）",
  email: "メールアドレス（任意）",
  personal_tel: "電話番号（任意）",
  position_name: "役職名 （任意）",
  company_name: "企業名 （任意）",
  company_tel: "企業電話番号 （任意）",
  company_fax: "企業FAX番号 （任意）",
  company_address: "企業住所 （任意）",
  company_postal_code: "企業郵便番号 （任意）",
  company_home_page: "企業ホームページ （任意）",
  delete: "削除フラグ",
};

export const tenantHeaderMapping = {
  id: "id",
  code: "コード",
  name: "企業名 ",
  name_kana: "企業名ふりがな ",
  postal_code: "郵便番号 ",
  address: "住所",
  phone_number: "電話番号",
  url: "企業URL",
  local_auth: "ログイン方法設定",
  require_passcode_for_phonebook: "電話帳参照制限",
  app_id: "APP ID",
  app_name: "APP名",
  status: "契約状態",
  contract_count: "ライセンス数",
  current_users: "利用者",
  start_date: "契約開始日",
  end_date: "契約終了日",
  // delete: "削除"
};

export const departmentHeaderMapping = {
  id: "id",
  display_order: "部署コード",
  name: "部署名",
  name_kana: "部署名かな（任意）",
  parent: "親部署コード（任意）",
  delete: "削除フラグ",
};

export const headerOrder = [
  "id",
  "code",
  "name",
  "name_kana",
  "last_name",
  "first_name",
  "last_furigana_name",
  "first_furigana_name",
  "employee_number",
  "postal_code",
  "address",
  "phone_number",
  "email",
  "url",
  "local_auth",
  "require_passcode_for_phonebook",
  "app_id",
  "app_name",
  "status",
  "contract_count",
  "current_users",
  "start_date",
  "end_date",
  "personal_tel",
  "login_id",
  "login_password",
  "is_display",
  "department",
  "role",
  "broadcast_group_code",
  "display_order",
  "tenant_department_id",
  "position_name",
  "apps",
  "company_name",
  "company_postal_code",
  "company_address",
  "company_tel",
  "company_fax",
  "company_home_page",
  "delete",
];

export const translateAndReorderHeaders = (headerMapping) => {
  const reorderedHeaders = headerOrder
    .map((key) => headerMapping[key])
    .filter((header) => header !== undefined && header !== null);

  return reorderedHeaders;
};

export const METHOD_TYPE_TRANSLATIONS: Record<METHOD_TYPE, string> = {
  [METHOD_TYPE.DELETE]: "削除",
  [METHOD_TYPE.CREATE]: "作成",
  [METHOD_TYPE.UPDATE]: "更新",
};
